export default __webpack_public_path__ + "static/media/money-back.d2555a5e.png";